import { Grid } from '@material-ui/core';
import { Dispatch, useContext, useState, VFC } from 'react';
import { useStyles } from './useStyles';
import { useForm, UseFormReturn, FormProvider } from 'react-hook-form';
import { SiteProcessTextfield } from '../../input/ProcessTextfield';
import {
  DECIMAL_VALIDATION,
  validationMessage
} from '../../../../const/ProcessConst';
import { TEditOperatingTimeForm } from '../../../../types/attendancManage';
import { BaseModal } from '../../../molecules/BaseModal';
import { AuthInfoContext } from '../../../../AuthContextProvider';
import { ROLE } from '../../../../const/Const';
import {
  updateOperatingTime,
  updateSiteProcess
} from '../../../../apicalls/attendanceManages';
import { checkResData } from '../../../../utils/common';
import { useSnackbar } from 'notistack';
import { createGanttResourceAndEvent } from '../../../../utils/attendancePage';
import { useRecoilState } from 'recoil';
import { attendanceGanttData } from '../../../../GlobalState';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  id: number;
  artificial: number;
  constructId: number;
  setIsLoading: Dispatch<boolean>;
};

export const AttendanceOperatingTimeEditModal: VFC<Props> = props => {
  const { isOpen, setIsOpen, id, artificial, constructId, setIsLoading } =
    props;
  const classes = useStyles();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);
  const { enqueueSnackbar } = useSnackbar();
  const [, setInitialGanttData] = useRecoilState(attendanceGanttData);

  const methods: UseFormReturn<TEditOperatingTimeForm> = useForm({
    reValidateMode: 'onSubmit',
    defaultValues: {
      id: id,
      artificial: artificial
    }
  });
  const {
    setValue,
    getValues,
    handleSubmit,
    reset,
    formState: { errors }
  } = methods;

  const cancelUpdate = () => {
    setIsOpen(false);
  };

  const update = (form: TEditOperatingTimeForm) => {
    setIsLoading(true);
    updateOperatingTime(form.id, form.artificial).then((resData: any) => {
      checkResData(resData, enqueueSnackbar)
        .then(async (data: any) => {
          if (data) {
            setIsOpen(false);
            const { resources, events } = await createGanttResourceAndEvent(
              constructId,
              enqueueSnackbar
            );
            setInitialGanttData({
              resources,
              events
            });
          }
        })
        .finally(() => setIsLoading(false));
    });
  };

  return (
    <BaseModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      handleSubmit={handleSubmit(update, (erros: any) => {})}
      handleCancelSubmit={cancelUpdate}
      title={'人工編集'}
      buttonCaption={'更新する'}
      cancelButtonCaption={'キャンセル'}
      editFlg={authInfo?.role != ROLE['OUTSIDE_PARTNER']}
    >
      <FormProvider {...methods}>
        {/* 計画人工 */}
        <Grid item xs={10} md={3} className={classes.gridItem}>
          <label className={classes.label}>計画人工*</label>
        </Grid>
        <Grid item xs={10} md={7}>
          <SiteProcessTextfield
            name='artificial'
            className={`${classes.input} ${classes.gridItem}`}
            pattern={DECIMAL_VALIDATION}
            patternMessage={validationMessage.decimal}
            max={9999.99}
            required={true}
            errorMessage={errors?.artificial?.message}
          />
        </Grid>
        {/* /計画人工 */}
      </FormProvider>
    </BaseModal>
  );
};
